import * as React from "react";

const UserGroup = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13 8C13 10.2094 11.2094 12 9 12C6.79062 12 5 10.2094 5 8C5 5.79063 6.79062 4 9 4C11.2094 4 13 5.79063 13 8ZM2 19.0719C2 15.9938 4.49375 13.5 7.57187 13.5H10.4281C13.5062 13.5 16 15.9938 16 19.0719C16 19.5844 15.5844 20 15.0719 20H2.92813C2.41563 20 2 19.5844 2 19.0719ZM21.0406 20H16.7312C16.9 19.7063 17 19.3656 17 19V18.75C17 16.8531 16.1531 15.15 14.8188 14.0063C14.8938 14.0031 14.9656 14 15.0406 14H16.9594C19.7438 14 22 16.2563 22 19.0406C22 19.5719 21.5687 20 21.0406 20ZM15.5 12C14.5312 12 13.6563 11.6063 13.0219 10.9719C13.6375 10.1406 14 9.1125 14 8C14 7.1625 13.7938 6.37188 13.4281 5.67813C14.0094 5.25313 14.725 5 15.5 5C17.4344 5 19 6.56563 19 8.5C19 10.4344 17.4344 12 15.5 12Z" />
  </svg>
);

export default UserGroup;
